//Don't exist catalog or enum for this for that reason is string value
const questionnaireStatus = {
  NotInterviewed: 'No Entrevistado',
  Submitted: 'Cuestionario Sometido',
  InProgress: 'En Proceso',
};

export default questionnaireStatus;
